angular.module('controllers').controller('foodProductController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$route', '$routeParams', '$location', '$timeout', '$window',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $route, $routeParams, $location, $timeout, $window) {
		$rootScope.path = '/food-product';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'food-product';
		$scope.pathTemplate = 'food/foodproducts';
		$scope.rootPublicPath = '/images';
		$scope.title = 'Produse';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.additionals['productImagePath'] = $scope.rootPublicPath+'/food_products';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';

		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'image':{'label':'Imagine', 'filter':0},
			'food_product_name':{'label':'Denumire', 'filter':1, 'filterType':'input'},
            'food_product_code':{'label':'Code', 'filter':1, 'filterType':'input'},
			'food_category_id':{'label':'Categorie', 'filter': 1, 'filterType': 'select', 'associate': 1, 'relation': 'foodCategory', 'colRelation': 'food_category_name'},
			'food_product_price':{'label':'Pret ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
			//'food_product_packaging':{'label':'Pret ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
			//'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};
		if($rootScope.settings['enable_packaging'] == 1) {
			$scope.columns.food_product_packaging = {'label':'Pret ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'};
		}

		/*$scope.columns.status = {'label':'Status', 'filter':1, 'filterType':'select'};
		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];*/

		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'food_product_name';
		$scope.dependedFields = [];

		$scope.additionals['type_orders'] = [
			{'value' : 'order_active', 'name' : 'Comenzi active'},
			{'value' : 'order_cancelled', 'name' : 'Comenzi anulate'}
		];

        $scope.additionals['type_products_incident'] = [
            {'value' : 0, 'name' : 'Produse fara incident'},
            {'value' : 1, 'name' : 'Produse cu incident'}
        ];

        $scope.additionals['type_orders_incident'] = [
            {'value' : 0, 'name' : 'Comenzi fara incident'},
            {'value' : 1, 'name' : 'Comenzi cu incident'},
            {'value' : 2, 'name' : 'Comenzi generate de incident'}
        ];

		$scope.additionals['discount_types'] = [
			{'id':0, 'value' : 'procent'},
			{'id':1, 'value' : 'suma fixa'}
		];

        $scope.additionals['recipeUnits'] = [
            {'id':0, 'value' : ''},
            {'id':1, 'value' : 'kg'},
            {'id':2, 'value' : 'l'},
            {'id':3, 'value' : 'buc'}
        ];

        $scope.additionals['recipeCategories'] = [
            {'id':0, 'value' : ''},
            {'id':1, 'value' : 'Materii prime'},
            {'id':2, 'value' : 'Semipreparate'},
            {'id':3, 'value' : 'Produs finit'},
            {'id':4, 'value' : 'Ambalaj'},
        ];

        $scope.search.display_menu = true;

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.dependedFields.push(data);

					$scope.additionals['settings'] = data.settings;

					$scope.additionals['dependedFields'] = $scope.dependedFields[0];

					$scope.getCategoryHierarchy = $scope.additionals['makeDropDown'](data.categories, 'food_category_name');
					$scope.additionals['categories'] =[];
                    if (!angular.isUndefined($scope.columns.food_category_id)) {
                        $scope.columns.food_category_id.options = [{id: '', value: ''}];
                        angular.forEach($scope.getCategoryHierarchy, function (item, key) {
                            $scope.additionals['categories'].push({id: item.id, value: item.food_category_name});
                            $scope.columns.food_category_id.options.push({id: item.id, value: item.food_category_name});
                        });
                    }
                    if (!angular.isUndefined($scope.columns.food_category_name)) {
                        angular.forEach($scope.getCategoryHierarchy, function (item, key) {
                            $scope.additionals['categories'].push({id: item.id, value: item.food_category_name});
                        });
                    }

					$scope.additionals['packaging'] = data.packaging;

                    $scope.additionals['recipeProducts'] = data.recipeProducts;
				});

		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

        $scope.additionals['searchTermOrigProduct'];
        $scope.additionals['clearSearchTermOrigProduct'] = function() {
            $scope.additionals['searchTermOrigProduct'] = '';
        };
        $scope.additionals['onSearchChangeOrigProduct'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.maxDate = new Date();
        $scope.minDate = '2010-01-01';
        var current_init_date = new Date();
        current_init_date.setHours(0,0,0,0);
        $scope.search.dateFrom = current_init_date;

        $scope.additionals['changeName']= function(model) {
             model.food_product_sku = model.food_product_name.toLowerCase();
        }

		$scope.additionals['function']= function(ev, model) {
			if (!angular.isUndefined($scope.selected) && $scope.action == 'updatemultiple') {
				angular.forEach(model, function (item, key) {
                    if (angular.isUndefined(item.food_product_sku)) {
                        item.food_product_sku = item.food_product_name.toLowerCase();
                	}
                    item.display_menu = $scope.additionals['getBoolField'](item.display_menu);
				});
			} else {

                if (angular.isUndefined(model.food_product_sku) && !angular.isUndefined(model.food_product_name)) {
                    model.food_product_sku = model.food_product_name.toLowerCase();
                }
                model.display_menu = $scope.additionals['getBoolField'](model.display_menu);
			}
		}

		/* multiple images */
		$scope.additionals['publicPath'] = $scope.rootPublicPath+'/food_products';
		if($scope.action == 'media') {
			$scope.additionals['content_type'] = 'undefined';
		}
		$scope.addMediaFoodProduct = function (ev, path, model, section) {
			$scope.addMediaModel(ev, path, model, section, 'undefined');
		}

		$scope.additionals['deleteImage'] = function (ev, model, imageId, image) {
			var post = {};
			post['route'] = 'deleteImage';
			post['image'] = image;
			post['id'] = model.id;
			Crud.post('form-urlencoded', post, $scope.path + '/deleteImage')
				.success(function () {
					var position = model['media'].map(function (e) {
						return e.id;
					}).indexOf(imageId);
					delete model['media'][position];

				}).error(function (data) {
				$scope.errors = data.errors;

			});
		}
		/* end multiple images */

		$scope.additionals['functionResult']= function(ev, data) {
			if (!angular.isUndefined($scope.modelData.food_product_name)) {
				$scope.modelData.food_product_name = $scope.additionals['formatTextResult']($scope.modelData.food_product_name);
			}
			if (!angular.isUndefined($scope.modelData.food_product_price)) {
				$scope.modelData.food_product_price =  $scope.additionals['formatDecimal']($scope.modelData.food_product_price);
			}
			if (!angular.isUndefined($scope.modelData.food_product_packaging)) {
				$scope.modelData.food_product_packaging =  $scope.additionals['formatDecimal']($scope.modelData.food_product_packaging);
			}
			if (!angular.isUndefined($scope.modelsData)) {
				angular.forEach($scope.modelsData, function (item, key) {
					if (!angular.isUndefined($scope.modelsData[key].food_product_name)) {
						$scope.modelsData[key].food_product_name = $scope.additionals['formatTextResult']($scope.modelsData[key].food_product_name);
					}
					if (!angular.isUndefined($scope.modelsData[key].food_product_price)) {
						$scope.modelsData[key].food_product_price = $scope.additionals['formatDecimal']($scope.modelsData[key].food_product_price);
					}
					if (!angular.isUndefined($scope.modelsData[key].food_product_packaging)) {
						$scope.modelsData[key].food_product_packaging = $scope.additionals['formatDecimal']($scope.modelsData[key].food_product_packaging);
					}

				});
			}
		}

		/* supplements */
		$scope.additionals['supplementOption'] = [
			{'id':'', 'value' : ''},
			{'id':0, 'value' : 'Simpla'},
			{'id':1, 'value' : 'Multipla'}
		];

		$scope.additionals['supplementTypePrice'] = [
			{'id':'', 'value' : ''},
			{'id':0, 'value' : 'Inclus'},
			{'id':1, 'value' : 'Extra'},
			{'id':2, 'value' : 'Precizat'}
		];

		$scope.additionals['getFoodCategories']= function(key) {
			//if (angular.isUndefined($scope.additionals['food_categories'])) {
			Crud.get($scope.path + '/getFoodCategories')
				.success(function (data) {
					$scope.additionals['food_categories'] = data.foodCategories;
				});
			//}
		}
        $scope.additionals['getFoodCategories']();

        $scope.additionals['getFoodCategoriesWithSupplements']= function(key) {
            Crud.get($scope.path + '/getFoodCategoriesWithSupplements')
                .success(function (data) {
                    $scope.additionals['food_categories_with_supplements'] = data.foodCategoriesWithSupplements;
                });
        }

		$scope.additionals['getCategorySupplement'] = function (check, product, category) {
			if(check == true) {
				$scope.modelData.supplements[product['id']]['food_category_id'] = category['food_category_id'];
                $scope.modelData.supplements[product['id']]['supplement_price'] = product['food_product_price'];
			}
		}

		$scope.additionals['getCategoryAllSupplements'] = function (model, check, category) {
			if (angular.isUndefined(model.supplements)) {
				model.supplements = {};
			}

			angular.forEach(category.food_products, function (product, key) {
				if (angular.isUndefined(model.supplements[product['id']])) {
					model.supplements[product['id']] = {};
				}
				model.supplements[product['id']]['selected'] = model.categories[category['food_category_id']]['selected'];

				model.supplements[product['id']]['supplement_option'] = model.categories[category['food_category_id']]['supplement_option'];

				model.supplements[product['id']]['supplement_type_price'] = model.categories[category['food_category_id']]['supplement_type_price'];

				model.supplements[product['id']]['supplement_price'] = model.categories[category['food_category_id']]['supplement_price'];

				model.supplements[product['id']]['food_category_id'] = category['food_category_id'];
            });

        }

		/* add supplements */
		$scope.addSupplementModel = function (ev, path, model, section) {
            $scope.additionals['getFoodCategories']();
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'supplement';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

				$scope.additionals['invalid'] = '';
				var currentModel = {};

				angular.forEach(model, function (item, key) {
					if(key == 'max_free') {
                        if(item != null) {
                            if (angular.isUndefined(currentModel['max'])) {
                                currentModel['max'] = [];
                            }
                            if (angular.isUndefined(currentModel['max_free'])) {
                                currentModel['max_free'] = [];
                            }
                            var maxArray = item.split(':');
                            currentModel['max'][maxArray[0]] = true;
                            currentModel['max_free'][maxArray[0]] = maxArray[1];
                        }
					} else {
                        currentModel[key] = item;
					}

				});
                $scope.modelData = currentModel;

                //console.log($scope.modelData['supplements'])
                $scope.additionals['checkExtra'] = function (category) {
					var controlExtra = {};
					if (Object.keys($scope.modelData['supplements']).length > 0) {
						angular.forEach($scope.modelData['supplements'], function (itemSup, keySup) {
							if (itemSup.food_category_id == category) {
								controlExtra[category] = 1;
								if (!angular.isUndefined(itemSup.extra)) {
									if (itemSup.extra == 0) {
										controlExtra[category] = 0;
									}
								}
							} else {
								controlExtra[category] = 0;
							}
						});
					} else {
						controlExtra[category] = 0;
					}
					return controlExtra;
                }
                $scope.modelData.extra = {};

                //console.log($scope.additionals['food_categories'])
                angular.forEach($scope.additionals['food_categories'], function (item, key) {
                    //console.log('contr='+$scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id]);
                    if($scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id] == 1) {
                        $scope.modelData.extra[item.food_category_id] = true;
                    }
                });
				//console.log($scope.modelData.extra)

				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				if (!angular.isUndefined($scope.additionals['function'])) {
					$scope.additionals['function'](ev, $scope.modelData);
				}

				$scope.addSupplement = function () {
                    $scope.additionals['buttonDisabled'] = true;
					if (!angular.isUndefined($scope.additionals['internFunction'])) {
						$scope.additionals['internFunction'](ev, $scope.modelData);
					}
					$scope.isLoading = true;
					$scope.modelData['route'] = 'supplement';
					Crud.post($scope.additionals['content_type'], $scope.modelData, path+'/supplement')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
								if (!angular.isUndefined($scope.additionals['functionResult'])) {
									$scope.additionals['functionResult'](ev, data);
								}
								/*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
								 $scope.selected[model[$rootScope.typeId]] = model;
								 }*/
								if (!angular.isUndefined(data.currentModel)) {
									if (!angular.isUndefined($scope.models)) {
										$scope.getElement($scope.models, data.currentModel);
									}
									if (!angular.isUndefined($scope.modelData)) {
										$scope.modelData = data.currentModel;
									}
								} else {
									if (!angular.isUndefined($scope.models)) {
										$scope.getElement($scope.models, currentModel);
									}
									if (!angular.isUndefined($scope.modelData)) {
										$scope.modelData = currentModel;
									}
								}
							}
							$scope.modelData = {};
							$scope.errors = {};
							$scope.isLoading = false;
							$scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.isLoading = false;
							$scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
						});
				};
			}
			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
                    if(key == 'max_free') {
                        if(item != null) {
                            if (angular.isUndefined(currentModel['max'])) {
                                currentModel['max'] = [];
                            }
                            if (angular.isUndefined(currentModel['max_free'])) {
                                currentModel['max_free'] = [];
                            }
                            var maxArray = item.split(':');
                            currentModel['max'][maxArray[0]] = true;
                            currentModel['max_free'][maxArray[0]] = maxArray[1];
                        }
                    } else {
                        currentModel[key] = item;
                    }
				});

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'supplementDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						pathTemplate: $scope.pathTemplate,
						section: section,
						model: currentModel,
						selected: $scope.selected,
						additionals: $scope.additionals
					}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
							}
							if (!angular.isUndefined($scope.modelData)) {
								$scope.modelData = $scope.additionals['dataCurrentModel'];
							}
						} else {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, currentModel, $rootScope.typeId);
							}
							if (!angular.isUndefined($scope.modelData)) {
								$scope.modelData = currentModel;
							}
						}
						if (!angular.isUndefined($scope.additionals['newDependentFields'])) {
							angular.forEach($scope.additionals['newDependentFields'], function (item, key) {
								$scope.additionals[key].push(item);
							});
						}
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.section = section;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

                    $scope.additionals['checkExtra'] = function (category) {
                        var controlExtra = {};
                        if (Object.keys($scope.modelData['supplements']).length > 0) {
                            angular.forEach($scope.modelData['supplements'], function (itemSup, keySup) {
                                if (itemSup.food_category_id == category) {
                                    controlExtra[category] = 1;
                                    if (!angular.isUndefined(itemSup.extra)) {
                                        if (itemSup.extra == 0) {
                                            controlExtra[category] = 0;
                                        }
                                    }
                                } else {
                                    controlExtra[category] = 0;
                                }
                            });
                        } else {
                            controlExtra[category] = 0;
                        }
                        return controlExtra;
                    }
                    $scope.modelData.extra = {};
                    angular.forEach($scope.additionals['food_categories'], function (item, key) {
                        if($scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id] == 1) {
                            $scope.modelData.extra[item.food_category_id] = true;
                        }
                    });

					if (!angular.isUndefined($scope.additionals['function'])) {
						$scope.additionals['function'](ev, $scope.modelData);
					}
					$scope.addSupplement = function () {
                        $scope.additionals['buttonDisabled'] = true;
						if (!angular.isUndefined($scope.additionals['internFunction'])) {
							$scope.additionals['internFunction'](ev, $scope.modelData);
						}
						$scope.isLoading = true;
						$scope.modelData['route'] = 'supplement';
						Crud.post($scope.additionals['content_type'], $scope.modelData, path+'/supplement')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									if (!angular.isUndefined($scope.additionals['functionResult'])) {
										$scope.additionals['functionResult'](ev, data);
									}
									/*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
									 $scope.selected[model[$rootScope.typeId]] = model;
									 }*/
									if (!angular.isUndefined(data.currentModel)) {
										$scope.additionals['dataCurrentModel'] = data.currentModel;
										$scope.additionals['newDependentFields'] = data.newDependentFields;
									}

								}
								$scope.isLoading = false;
								$mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
							})
							.error(function (data) {
								$scope.isLoading = false;
								$scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
							});
					};
				}
			}

		};

        $scope.addSupplementCategoryModel = function (ev, path, model, section) {
            $scope.additionals['getFoodCategoriesWithSupplements']();
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'supplementCategory';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                $scope.modelData = currentModel;

                $scope.additionals['fillSupplements'] = function (model) {

                    if (angular.isUndefined(model.supplements)) {
                        model.supplements = {};
                    }
                    angular.forEach($scope.additionals['food_categories_with_supplements'], function (category, keyCat) {
                        if(model.food_category_id == category['food_category_id']) {
                            angular.forEach(category.food_products[0].supplements, function (supplement, keySup) {
                                if (angular.isUndefined(model.supplements[supplement['supplement_id']])) {
                                    model.supplements[supplement['supplement_id']] = {};
                                }
                                model.supplements[supplement['supplement_id']]['selected'] = supplement['selected'];
                                model.supplements[supplement['supplement_id']]['supplement_option'] = supplement['supplement_option'];
                                model.supplements[supplement['supplement_id']]['supplement_type_price'] = supplement['supplement_type_price'];
                                model.supplements[supplement['supplement_id']]['supplement_price'] = supplement['supplement_price'];
                                model.supplements[supplement['supplement_id']]['food_category_id'] = supplement['food_category_id'];
                                model.supplements[supplement['supplement_id']]['regular'] = supplement['regular'];
                                model.supplements[supplement['supplement_id']]['extra'] = supplement['extra'];
                            });
                        }
                    });

                    $scope.additionals['checkExtra'] = function (category) {
                        var controlExtra = {};
                        if (Object.keys($scope.modelData['supplements']).length > 0) {
                            angular.forEach($scope.modelData['supplements'], function (itemSup, keySup) {
                                if (itemSup.food_category_id == category) {
                                    controlExtra[category] = 1;
                                    if (!angular.isUndefined(itemSup.extra)) {
                                        if (itemSup.extra == 0) {
                                            controlExtra[category] = 0;
                                        }
                                    }
                                } else {
                                    controlExtra[category] = 0;
                                }
                            });
                        } else {
                            controlExtra[category] = 0;
                        }
                        return controlExtra;
                    }

                    $scope.modelData.extra = {};
                    angular.forEach($scope.additionals['food_categories'], function (item, key) {
                        if($scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id] == 1) {
                            $scope.modelData.extra[item.food_category_id] = true;
                        }
                    });

                }

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                if (!angular.isUndefined($scope.additionals['function'])) {
                    $scope.additionals['function'](ev, $scope.modelData);
                }

                $scope.addSupplementCategory = function () {
                    $scope.additionals['buttonDisabled'] = true;
                    if (!angular.isUndefined($scope.additionals['internFunction'])) {
                        $scope.additionals['internFunction'](ev, $scope.modelData);
                    }
                    $scope.isLoading = true;
                    $scope.modelData['route'] = 'supplementCategory';
                    Crud.post($scope.additionals['content_type'], $scope.modelData, path+'/supplementcategory')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                    $scope.additionals['functionResult'](ev, data);
                                }
								if (!angular.isUndefined(data.currentModels)) {
									angular.forEach(data.currentModels, function (items, index) {
										$scope.getElement($scope.models, data.currentModels[items['id']]);
									});
								}
                            }
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });
                };
            }
            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    currentModel[key] = item;
                });
                var models = $scope.models;

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'supplementCategoryDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        section: section,
                        model: currentModel,
                        selected: $scope.selected,
                        additionals: $scope.additionals,
                        models: $scope.models
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                            }
                        } else {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = currentModel;
                            }
                        }
                        if (!angular.isUndefined($scope.additionals['newDependentFields'])) {
                            angular.forEach($scope.additionals['newDependentFields'], function (item, key) {
                                $scope.additionals[key].push(item);
                            });
                        }
                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals', 'models'];
                function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals, models) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.section = section;
                    $scope.models = models;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.additionals['fillSupplements'] = function (model) {
                        if (angular.isUndefined(model.supplements)) {
                            model.supplements = {};
                        }
                        angular.forEach($scope.additionals['food_categories_with_supplements'], function (category, keyCat) {
                            if(model.food_category_id == category['food_category_id']) {
                                angular.forEach(category.food_products[0].supplements, function (supplement, keySup) {
                                    if (angular.isUndefined(model.supplements[supplement['supplement_id']])) {
                                        model.supplements[supplement['supplement_id']] = {};
                                    }
                                    model.supplements[supplement['supplement_id']]['selected'] = supplement['selected'];
                                    model.supplements[supplement['supplement_id']]['supplement_option'] = supplement['supplement_option'];
                                    model.supplements[supplement['supplement_id']]['supplement_type_price'] = supplement['supplement_type_price'];
                                    model.supplements[supplement['supplement_id']]['supplement_price'] = supplement['supplement_price'];
                                    model.supplements[supplement['supplement_id']]['food_category_id'] = supplement['food_category_id'];
                                });
                            }
                        });

                        $scope.additionals['checkExtra'] = function (category) {
                            var controlExtra = {};
                            if (Object.keys($scope.modelData['supplements']).length > 0) {
                                angular.forEach($scope.modelData['supplements'], function (itemSup, keySup) {
                                    if (itemSup.food_category_id == category) {
                                        controlExtra[category] = 1;
                                        if (!angular.isUndefined(itemSup.extra)) {
                                            if (itemSup.extra == 0) {
                                                controlExtra[category] = 0;
                                            }
                                        }
                                    } else {
                                        controlExtra[category] = 0;
                                    }
                                });
                            } else {
                                controlExtra[category] = 0;
                            }
                            return controlExtra;
                        }
                        $scope.modelData.extra = {};
                        angular.forEach($scope.additionals['food_categories'], function (item, key) {
                            if($scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id] == 1) {
                                $scope.modelData.extra[item.food_category_id] = true;
                            }
                        });
                        //console.log($scope.modelData.extra)

                    }

                    if (!angular.isUndefined($scope.additionals['function'])) {
                        $scope.additionals['function'](ev, $scope.modelData);
                    }
                    $scope.addSupplementCategory = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        if (!angular.isUndefined($scope.additionals['internFunction'])) {
                            $scope.additionals['internFunction'](ev, $scope.modelData);
                        }
                        $scope.isLoading = true;
                        $scope.modelData['route'] = 'supplementCategory';
                        Crud.post($scope.additionals['content_type'], $scope.modelData, path+'/supplementcategory')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                    if (!angular.isUndefined(data.currentModels)) {
                                        angular.forEach(data.currentModels, function (items, index) {
                                            $scope.additionals['getElement']($scope.models, data.currentModels[items['id']]);
                                        });
                                    }
                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                    };
                }
            }

        };

		$scope.additionals['getFoodCategoriesBySupplementId']= function(food_product_id) {
			Crud.get($scope.path + '/getFoodCategoriesBySupplementId?food_product_id='+food_product_id)
				.success(function (data) {
					$scope.additionals['food_categories_by_supplement_id'] = data.foodCategories;
				});
		}

		/* change order down */
		$scope.additionals['changeOrderDown'] = function (model, category) {
			$scope.additionals['invalid'] = '';
			$scope.additionals['buttonDisabled'] = true;
			var datas = '';
			$scope.additionals['food_categories_by_supplement_id'] = $filter('orderBy')($scope.additionals['food_categories_by_supplement_id'], $scope.sortType, $scope.sortReverse);

			$scope.sortType = '';
			$scope.sortReverse = false;

			var position = $scope.additionals['food_categories_by_supplement_id'].map(function (e) {
				return e.food_category_id;
			}).indexOf(category['food_category_id']);

			datas = $scope.additionals['food_categories_by_supplement_id'].slice(position, position+2);
			var aux = datas[1];
			datas[1] = datas[0];
			datas[0] = aux;

			$scope.additionals['food_categories_by_supplement_id'][position] = datas[0];
			$scope.additionals['food_categories_by_supplement_id'][position+1] = datas[1];

			var auxOrder = $scope.additionals['food_categories_by_supplement_id'][position+1].supplement_category_order;
			$scope.additionals['food_categories_by_supplement_id'][position+1].supplement_category_order = $scope.additionals['food_categories_by_supplement_id'][position].supplement_category_order;
			$scope.additionals['food_categories_by_supplement_id'][position].supplement_category_order = auxOrder;

			var post = {};
			post['models'] = $scope.additionals['food_categories_by_supplement_id'];
			post['food_product_id'] = model['id'];
			post['route'] = 'sortsupplementcategory';

			Crud.post($scope.additionals['content_type'], post, $scope.path+'/sortsupplementcategory')
				.success(function (data) {
					$scope.additionals['buttonDisabled'] = false;
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						$scope.additionals['food_categories_by_supplement_id'] = data.foodCategories;
					}
				});
		}

		/* change order up */
		$scope.additionals['changeOrderUp'] = function (model, category) {
			$scope.additionals['invalid'] = '';
			$scope.additionals['buttonDisabled'] = true;
			var datas = '';
			$scope.additionals['food_categories_by_supplement_id'] = $filter('orderBy')($scope.additionals['food_categories_by_supplement_id'], $scope.sortType, $scope.sortReverse);

			$scope.sortType = '';
			$scope.sortReverse = false;

			var position = $scope.additionals['food_categories_by_supplement_id'].map(function (e) {
				return e.food_category_id;
			}).indexOf(category['food_category_id']);

			datas = $scope.additionals['food_categories_by_supplement_id'].slice(position-1, position+1);
			var aux = datas[1];
			datas[1] = datas[0];
			datas[0] = aux;

			$scope.additionals['food_categories_by_supplement_id'][position-1] = datas[0];
			$scope.additionals['food_categories_by_supplement_id'][position] = datas[1];

			var auxOrder = $scope.additionals['food_categories_by_supplement_id'][position-1].supplement_category_order;
			$scope.additionals['food_categories_by_supplement_id'][position-1].supplement_category_order = $scope.additionals['food_categories_by_supplement_id'][position].supplement_category_order;
			$scope.additionals['food_categories_by_supplement_id'][position].supplement_category_order = auxOrder;

			var post = {};
			post['models'] = $scope.additionals['food_categories_by_supplement_id'];
			post['food_product_id'] = model['id'];
			post['route'] = 'sortsupplementcategory';

			Crud.post($scope.additionals['content_type'], post, $scope.path+'/sortsupplementcategory')
				.success(function (data) {
					$scope.additionals['buttonDisabled'] = false;
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						$scope.additionals['food_categories_by_supplement_id'] = data.foodCategories;
					}
				});
		}

		$scope.sortSupplementCategoryModel = function (ev, path, model, section) {
			$scope.additionals['getFoodCategoriesBySupplementId'](model.id);
			if($scope.mode_action == 'page') {
				$scope.controlSH = true;
				$scope.action = 'sortsupplementcategory';
				angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");

				$scope.additionals['invalid'] = '';
				var currentModel = {};

				angular.forEach(model, function (item, key) {
					if(key == 'max_free') {
						if(item != null) {
							if (angular.isUndefined(currentModel['max'])) {
								currentModel['max'] = [];
							}
							if (angular.isUndefined(currentModel['max_free'])) {
								currentModel['max_free'] = [];
							}
							var maxArray = item.split(':');
							currentModel['max'][maxArray[0]] = true;
							currentModel['max_free'][maxArray[0]] = maxArray[1];
						}
					} else {
						currentModel[key] = item;
					}

				});
				$scope.modelData = currentModel;

				//console.log($scope.modelData['supplements'])
				$scope.additionals['checkExtra'] = function (category) {
					var controlExtra = {};
					if (Object.keys($scope.modelData['supplements']).length > 0) {
						angular.forEach($scope.modelData['supplements'], function (itemSup, keySup) {
							if (itemSup.food_category_id == category) {
								controlExtra[category] = 1;
								if (!angular.isUndefined(itemSup.extra)) {
									if (itemSup.extra == 0) {
										controlExtra[category] = 0;
									}
								}
							} else {
								controlExtra[category] = 0;
							}
						});
					} else {
						controlExtra[category] = 0;
					}
					return controlExtra;
				}
				$scope.modelData.extra = {};

				//console.log($scope.additionals['food_categories'])
				angular.forEach($scope.additionals['food_categories'], function (item, key) {
					//console.log('contr='+$scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id]);
					if($scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id] == 1) {
						$scope.modelData.extra[item.food_category_id] = true;
					}
				});
				//console.log($scope.modelData.extra)

				$scope.cancel = function () {
					$scope.modelData = {};
					$scope.errors = {};
					$scope.controlSH = false;
				};

				if (!angular.isUndefined($scope.additionals['function'])) {
					$scope.additionals['function'](ev, $scope.modelData);
				}

                $scope.sortSupplementCategory = function () {
                    var post = {};
                    post['models'] = $scope.additionals['food_categories_by_supplement_id'];
                    post['food_product_id'] = model['id'];
                    post['route'] = 'sortsupplementcategory';

                    Crud.post($scope.additionals['content_type'], post, $scope.path + '/sortsupplementcategory')
                        .success(function (data) {
                            $scope.additionals['buttonDisabled'] = false;
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                $scope.additionals['food_categories_by_supplement_id'] = data.foodCategories;
                            }
                        });
                }

			}

			if($scope.mode_action == 'dialog') {
				$scope.additionals['invalid'] = '';
				var currentModel = {};
				angular.forEach(model, function (item, key) {
					if(key == 'max_free') {
						if(item != null) {
							if (angular.isUndefined(currentModel['max'])) {
								currentModel['max'] = [];
							}
							if (angular.isUndefined(currentModel['max_free'])) {
								currentModel['max_free'] = [];
							}
							var maxArray = item.split(':');
							currentModel['max'][maxArray[0]] = true;
							currentModel['max_free'][maxArray[0]] = maxArray[1];
						}
					} else {
						currentModel[key] = item;
					}
				});

				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'sortSupplementCategoryDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {
						pathTemplate: $scope.pathTemplate,
						section: section,
						model: currentModel,
						selected: $scope.selected,
						additionals: $scope.additionals
					}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
							}
							if (!angular.isUndefined($scope.modelData)) {
								$scope.modelData = $scope.additionals['dataCurrentModel'];
							}
						} else {
							if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
								$scope.getElement($scope.models, currentModel, $rootScope.typeId);
							}
							if (!angular.isUndefined($scope.modelData)) {
								$scope.modelData = currentModel;
							}
						}
						if (!angular.isUndefined($scope.additionals['newDependentFields'])) {
							angular.forEach($scope.additionals['newDependentFields'], function (item, key) {
								$scope.additionals[key].push(item);
							});
						}
					}
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.modelData = model;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.section = section;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					$scope.additionals['checkExtra'] = function (category) {
						var controlExtra = {};
						if (Object.keys($scope.modelData['supplements']).length > 0) {
							angular.forEach($scope.modelData['supplements'], function (itemSup, keySup) {
								if (itemSup.food_category_id == category) {
									controlExtra[category] = 1;
									if (!angular.isUndefined(itemSup.extra)) {
										if (itemSup.extra == 0) {
											controlExtra[category] = 0;
										}
									}
								} else {
									controlExtra[category] = 0;
								}
							});
						} else {
							controlExtra[category] = 0;
						}
						return controlExtra;
					}
					$scope.modelData.extra = {};
					angular.forEach($scope.additionals['food_categories'], function (item, key) {
						if($scope.additionals['checkExtra'](item.food_category_id)[item.food_category_id] == 1) {
							$scope.modelData.extra[item.food_category_id] = true;
						}
					});

					if (!angular.isUndefined($scope.additionals['function'])) {
						$scope.additionals['function'](ev, $scope.modelData);
					}

				}
			}

		};

		$scope.additionals['dropCallbackSupplementCategory'] = function(index, category, model) {

			$scope.additionals['invalid'] = '';
			var datas = '';
			$scope.additionals['food_categories_by_supplement_id'] = $filter('orderBy')($scope.additionals['food_categories_by_supplement_id'], $scope.sortType, $scope.sortReverse);

			$scope.sortType = '';
			$scope.sortReverse = false;

			var position = $scope.additionals['food_categories_by_supplement_id'].map(function (e) {
				return e.food_category_id;
			}).indexOf(category['food_category_id']);

			var existRow = $scope.additionals['food_categories_by_supplement_id'][position];
			$scope.additionals['food_categories_by_supplement_id'].splice(position, 1);
			$scope.additionals['food_categories_by_supplement_id'].splice(index, 0, existRow);

			var post = {};
			post['models'] = $scope.additionals['food_categories_by_supplement_id'];
			post['food_product_id'] = model['id'];
			post['route'] = 'sortsupplementcategory';

			Crud.post($scope.additionals['content_type'], post, $scope.path+'/sortsupplementcategory')
				.success(function (data) {
					if (!angular.isUndefined(data.invalid)) {
						$scope.additionals['invalid'] = data.invalid;
					} else {
						$scope.additionals['food_categories_by_supplement_id'] = data.foodCategories;
					}
				});

			return category;
		};
		/* end supplements */

		/*add ingredients*/
        function createFilterForIngredient(query) {
            var lowercaseQuery = angular.lowercase(query);
            return function filterFn(item) {
                return item.ingredient_name.indexOf(lowercaseQuery) >= 0;
            };
        }

        $scope.additionals['ingredientsResults'] = [];
        $scope.additionals['getIngredients'] = function(model) {
			Crud.get($scope.path + '/getIngredients')
				.success(function (data) {
					$scope.additionals['ingredientsResults'] = data.ingredients;

					/*autocomplete*/
					function querySearch(query) {
						var results = query ? $scope.additionals['ingredientsResults'].filter(createFilterForIngredient(query)) : [];
						return results;
					}
					$scope.additionals['searchIngredient'] = querySearch;
					$scope.additionals['errors'] = {};
					/*end autocomplete*/
				});
        }

        $scope.additionals['selectedItemIngredient'] = [];

        /* add multiple ingredient forms */
        $scope.additionals['ingredients'] = [{}];
        $scope.additionals['cloneItem'] = function (model, modelLength) {
            var itemToClone = {};
            $scope.additionals[model].push(itemToClone);

            angular.forEach($scope.modelData[model], function (item, key) {
                $scope.additionals['selectedItemIngredient'][$scope.additionals[model].length -1] = '';
            });
        }

        $scope.additionals['removeItem']= function (itemIndex, modelIngredient) {
            if(!angular.isUndefined($scope.errors) ) {
                if(!angular.isUndefined($scope.errors['ingredients.' + itemIndex + '.ingredient_name']) ) {
                    delete $scope.errors['ingredients.' + itemIndex + '.ingredient_name'];
                }
                if(!angular.isUndefined($scope.errors['ingredients.' + itemIndex + '.ingredient_id']) ) {
                    delete $scope.errors['ingredients.'+itemIndex+'.ingredient_id'];
                }
            }

            $scope.interm = [];
            angular.forEach($scope.additionals[modelIngredient], function (itemy, indexy) {
                $scope.interm[indexy] = {
                    'ingredient_id' : itemy['ingredient_id'],
                    'ingredient_name' : itemy['ingredient_name'],
                    'recipe_quantity' : itemy['recipe_quantity'],
                    'recipe_unit' : itemy['recipe_unit'],
                    'recipe_category' : itemy['recipe_category'],
                    'orig_food_product_id' : itemy['orig_food_product_id']
                };
            });
            $scope.interms = [];
            angular.forEach($scope.interm, function (itemyy, indexyy) {
                $scope.interms.push({
                    'ingredient_id' : itemyy['ingredient_id'],
                    'ingredient_name' : itemyy['ingredient_name'],
                    'recipe_quantity' : itemyy['recipe_quantity'],
                    'recipe_unit' : itemyy['recipe_unit'],
                    'recipe_category' : itemyy['recipe_category'],
                    'orig_food_product_id' : itemyy['orig_food_product_id']
                });
            });
            $scope.interms.splice(itemIndex, 1);
            $scope.additionals[modelIngredient] = $scope.interms;

            $timeout(function() {
                $scope.modelData.ingredients = $scope.additionals[modelIngredient];
            }, 100);

        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, model, keyIngredient, key) {
            if (!angular.isUndefined(key)) {
                model[key][paramName] = '';
            } else {
                model.ingredients[keyIngredient][paramName] = '';
            }
        }
        /* change field */
        $scope.additionals['changeField']= function(model, prop, indexIngredient) {
            if(prop == 'ingredient') {
                if(!angular.isUndefined(model.ingredients[indexIngredient]) ) {
                    model.ingredients[indexIngredient].ingredient_new = false;
                }
			}
        }

        $scope.addIngredientModel = function (ev, path, model, section) {
            $scope.additionals['getIngredients']();
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'ingredient';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.additionals['invalid'] = '';

                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    switch (key) {
                        case 'ingredients':
                            currentModel['ingredients'] = [];
                            angular.forEach(item, function (itemIngredients, keyIngredients) {
                                $scope.additionals['selectedItemIngredient'][keyIngredients] = '';

                                currentModel['ingredients'][keyIngredients] = {};
                                angular.forEach(itemIngredients, function (itemIngredientsDetail, keyIngredientsDetail) {
                                    currentModel['ingredients'][keyIngredients][keyIngredientsDetail] = itemIngredientsDetail;
                                });
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });
                $scope.modelData = currentModel;
                if(angular.isUndefined(currentModel.ingredients) || currentModel.ingredients.length == 0) {
                    currentModel.ingredients = [{}];
                }
                $scope.additionals['ingredients'] = currentModel.ingredients;

                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };

                $scope.addIngredient = function () {

                    angular.forEach($scope.modelData.ingredients, function (item, indexIngredients) {
                           if (item['ingredient_name'] != '' && $scope.additionals['ingredientsResults']) {
                            var checkIngredientId = $scope.additionals['checkField']($scope.additionals['ingredientsResults'], 'id', 'ingredient_name', item['ingredient_name']);
                            if (checkIngredientId) {
                                item.ingredient_id = checkIngredientId;
                            } else {
                                item.ingredient_id = 0;
                            }
                            var checkIngredientName = $scope.additionals['checkField']($scope.additionals['ingredientsResults'], 'ingredient_name', 'ingredient_name', item['ingredient_name']);
                            if (checkIngredientName) {
                                item.ingredient_name = checkIngredientName;
                            }
                        }
                    });
                    $scope.additionals['buttonDisabled'] = true;
                    $scope.isLoading = true;
                    var post = {};
                    post['route'] = 'ingredient';
                    post['ingredients'] = $scope.modelData['ingredients'];
                    post['id'] = $scope.modelData['id'];
                    Crud.post($scope.additionals['content_type'], post, path+'/ingredient')
                        .success(function (data) {
                            if (!angular.isUndefined(data.invalid)) {
                                $scope.additionals['invalid'] = data.invalid;
                            } else {
                                if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                    $scope.additionals['functionResult'](ev, data);
                                }
                                /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                 $scope.selected[model[$rootScope.typeId]] = model;
                                 }*/
                                if (!angular.isUndefined(data.currentModel)) {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, data.currentModel);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = data.currentModel;
                                    }
                                } else {
                                    if (!angular.isUndefined($scope.models)) {
                                        $scope.getElement($scope.models, currentModel);
                                    }
                                    if (!angular.isUndefined($scope.modelData)) {
                                        $scope.modelData = currentModel;
                                    }
                                }
                            }
                            $scope.modelData = {};
                            $scope.errors = {};
                            $scope.isLoading = false;
                            $scope.controlSH = false;
                            $scope.additionals['buttonDisabled'] = false;
                        })
                        .error(function (data) {
                            $scope.isLoading = false;
                            $scope.errors = data.errors;
                            $scope.additionals['buttonDisabled'] = false;
                        });
                };
            }
            if($scope.mode_action == 'dialog') {
                $scope.additionals['invalid'] = '';
                var currentModel = {};
                angular.forEach(model, function (item, key) {
                    switch (key) {
                        case 'ingredients':
                            currentModel['ingredients'] = [];
                            angular.forEach(item, function (itemIngredients, keyIngredients) {
                                $scope.additionals['selectedItemIngredient'][keyIngredients] = '';

                                currentModel['ingredients'][keyIngredients] = {};
                                angular.forEach(itemIngredients, function (itemIngredientsDetail, keyIngredientsDetail) {
                                    currentModel['ingredients'][keyIngredients][keyIngredientsDetail] = itemIngredientsDetail;
                                });
                            });
                            break;
                        default:
                            currentModel[key] = item;
                            break;
                    }
                });

                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'ingredientDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        pathTemplate: $scope.pathTemplate,
                        section: section,
                        model: currentModel,
                        selected: $scope.selected,
                        additionals: $scope.additionals
                    }
                }).then(function () {
                    if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
                        if (!angular.isUndefined($scope.additionals['dataCurrentModel'])) {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, $scope.additionals['dataCurrentModel']);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = $scope.additionals['dataCurrentModel'];
                            }
                        } else {
                            if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                $scope.getElement($scope.models, currentModel, $rootScope.typeId);
                            }
                            if (!angular.isUndefined($scope.modelData)) {
                                $scope.modelData = currentModel;
                            }
                        }
                        if (!angular.isUndefined($scope.additionals['newDependentFields'])) {
                            angular.forEach($scope.additionals['newDependentFields'], function (item, key) {
                                $scope.additionals[key].push(item);
                            });
                        }
                    }
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'section', 'model', 'selected', 'additionals'];
                function DialogController($scope, $mdDialog, pathTemplate, section, model, selected, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.modelData = model;
                    $scope.additionals = additionals;
                    $scope.selected = selected;
                    $scope.section = section;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };

                    $scope.additionals['removeItem']= function (itemIndex, modelIngredient) {
                        if(!angular.isUndefined($scope.errors) ) {
                            if(!angular.isUndefined($scope.errors['ingredients.' + itemIndex + '.ingredient_name']) ) {
                                delete $scope.errors['ingredients.' + itemIndex + '.ingredient_name'];
                            }
                            if(!angular.isUndefined($scope.errors['ingredients.' + itemIndex + '.ingredient_id']) ) {
                                delete $scope.errors['ingredients.'+itemIndex+'.ingredient_id'];
                            }
                        }

                        $scope.interm = [];
                        angular.forEach($scope.additionals[modelIngredient], function (itemy, indexy) {
                            $scope.interm[indexy] = {
                                'ingredient_id' : itemy['ingredient_id'],
                                'ingredient_name' : itemy['ingredient_name'],
                                'recipe_quantity' : itemy['recipe_quantity'],
                                'recipe_unit' : itemy['recipe_unit'],
                                'recipe_category' : itemy['recipe_category'],
                                'orig_food_product_id' : itemy['orig_food_product_id']
                            };
                        });
                        $scope.interms = [];
                        angular.forEach($scope.interm, function (itemyy, indexyy) {
                            $scope.interms.push({
                                'ingredient_id' : itemyy['ingredient_id'],
                                'ingredient_name' : itemyy['ingredient_name'],
                                'recipe_quantity' : itemyy['recipe_quantity'],
                                'recipe_unit' : itemy['recipe_unit'],
                                'recipe_category' : itemy['recipe_category'],
                                'orig_food_product_id' : itemy['orig_food_product_id']
                            });
                        });
                        $scope.interms.splice(itemIndex, 1);
                        $scope.additionals[modelIngredient] = $scope.interms;

                        $timeout(function() {
                            $scope.modelData.ingredients = $scope.additionals[modelIngredient];
                        }, 100);

                    }

                    if(angular.isUndefined($scope.modelData.ingredients) || $scope.modelData.ingredients.length == 0) {
                        $scope.modelData.ingredients = [{}];
                    }
                    $scope.additionals['ingredients'] = $scope.modelData.ingredients;

                    $scope.addIngredient = function () {

                        angular.forEach($scope.modelData.ingredients, function (item, indexIngredients) {
                            if (item['ingredient_name'] != '' && $scope.additionals['ingredientsResults']) {
                                var checkIngredientId = $scope.additionals['checkField']($scope.additionals['ingredientsResults'], 'id', 'ingredient_name', item['ingredient_name']);
                                if (checkIngredientId) {
                                    item.ingredient_id = checkIngredientId;
                                } else {
                                    item.ingredient_id = 0;
                                }
                                var checkIngredientName = $scope.additionals['checkField']($scope.additionals['ingredientsResults'], 'ingredient_name', 'ingredient_name', item['ingredient_name']);
                                if (checkIngredientName) {
                                    item.ingredient_name = checkIngredientName;
                                }
                            }
                        });

                        $scope.isLoading = true;
                        $scope.additionals['buttonDisabled'] = true;
                        var post = {};
                        post['route'] = 'ingredient';
                        post['ingredients'] = $scope.modelData['ingredients'];
                        post['id'] = $scope.modelData['id'];
                        Crud.post($scope.additionals['content_type'], post, path+'/ingredient')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined($scope.additionals['functionResult'])) {
                                        $scope.additionals['functionResult'](ev, data);
                                    }
                                    /*if (!angular.isUndefined($scope.selected[model[$rootScope.typeId]])) {
                                     $scope.selected[model[$rootScope.typeId]] = model;
                                     }*/
                                    if (!angular.isUndefined(data.currentModel)) {
                                        $scope.additionals['dataCurrentModel'] = data.currentModel;
                                        $scope.additionals['newDependentFields'] = data.newDependentFields;
                                    }

                                }
                                $scope.isLoading = false;
                                $mdDialog.hide();
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                    };
                }
            }

        };
        /*end add ingredients*/

        /* reports */
		if($rootScope.settings.enable_packaging == 1) {
			$scope.nonDisplay = 0;
		} else {
			$scope.nonDisplay = 1;
		}
		$scope.printReport = $window;
		$scope.isLoadingPrinter = false;
		$scope.printPreview = function (ev, path, availableColumns, columns) {

			$scope.isLoadingPrinter = true;
			var popup = $scope.printReport.open('', '_blank', 'width=800,height=300,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no,top=50');
			popup.document.open();

			Crud.search($scope.search, path, 1, 'p')
				.success(function (data) {
					$scope.isLoadingPagination = false;
					$scope.isLoadingPrinter = false;

					$scope.additionals['buttonDisabledPagination'] = false;
					var printColumns = {};
					if (!angular.isUndefined(availableColumns) && availableColumns.length > 0) {
						angular.forEach(columns, function (item, index) {
							if (availableColumns.indexOf(index) >= 0) {
								printColumns[index] = item;
							}
						});
					} else {
						printColumns = columns;
					}
					var title = 'Raport ';
					if($scope.search['reportType'] == 'reportDetail') {
						title = title + 'detaliat';
					}
					if($scope.search['reportType'] == 'reportDaily') {
						title = title + 'zilnic';
					}
					title = title + '  ';
					if ($scope.search['dateFrom']) {
						title = title + moment($scope.search['dateFrom']).format('DD/MM/YY');
					}
					if ($scope.search['timeFrom']) {
						title = title + moment($scope.search['timeFrom']).format(' HH:mm:ss');
					}
					if ($scope.search['dateFrom'] || $scope.search['timeFrom']) {
						title = title + '   ';
					}
					if ($scope.search['dateTo']) {
						title = title + moment($scope.search['dateTo']).format('DD/MM/YY');
					}
					if ($scope.search['timeTo']) {
						title = title + moment($scope.search['timeTo']).format(' HH:mm:ss');
					}

					var html = '<div class="report-print">';
					var orders = data.data;
					if (orders.length > 0) {
						html = html + '<table><tr>';
						html = html + '<th>Nr.</th>';
						angular.forEach(printColumns, function (itemColumn, keyColumn) {
							if(!itemColumn['nonDisplay']) {
								html = html + '<th>' + itemColumn['label'] + '</th>';
							}
						});
						html = html + '</tr>';

						var total_quantity = 0;
						var total_price = 0;
						var total_packaging = 0
						var total_product_discount = 0;
						var total = 0;

						angular.forEach(orders, function (item, key) {
							html = html + '<tr>';
							var keys = key + 1;
							html = html + '<td>' + keys + '</td>';
							angular.forEach(printColumns, function (itemColumn, keyColumn) {
								if(!itemColumn['nonDisplay']) {
									if (itemColumn['filterType'] == 'select') {
										if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
											html = html + '<td>' + $scope.additionals['associativeColumn'](printColumns[keyColumn], item[keyColumn]) + '</td>';
										} else {
											html = html + '<td></td>';
										}
									} else {
										if (!angular.isUndefined(item[keyColumn]) && item[keyColumn] != '') {
											html = html + '<td>' + item[keyColumn] + '</td>';
										} else {
											html = html + '<td></td>';
										}
									}
								}
							});
							html = html + '</tr>';

							total_quantity = total_quantity + parseInt(item['total_quantity']);
							total_price = total_price + parseFloat(item['total_price']);
							total_packaging = total_packaging + parseFloat(item['total_packaging']);
							total_product_discount = total_product_discount + parseFloat(item['total_product_discount']);
							total = total + parseFloat(item['total']);
						});

						html = html + '<tr>';
						html = html + '<td>Total</td>';
						angular.forEach(printColumns, function (itemColumn, keyColumn) {
							if(!itemColumn['nonDisplay']) {
								if (keyColumn == 'total_quantity') {
									html = html + '<td class="align-right total">' + total_quantity + '</td>';
								} else if (keyColumn == 'total_price') {
									html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_price) + '</td>';
								} else if (keyColumn == 'total_packaging') {
									html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_packaging) + '</td>';
								} else if (keyColumn == 'total_product_discount') {
									html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total_product_discount) + '</td>';
								} else if (keyColumn == 'total') {
									html = html + '<td class="align-right total">' + $scope.additionals['formatDecimal'](total) + '</td>';
								} else {
									html = html + '<td></td>';
								}
							}
						});
						html = html + '</tr>';

						html = html + '</table>';
					}

					popup.document.write('<!DOCTYPE html><html><head><title>'+ title +'</title>'
						+ '<link rel="stylesheet" type="text/css" href="/css/print-preview.css" />'
						+ '</head><body onload="window.print(); window.close();">'
						+ html
						+ '</body></html>');
					//popup.document.close();

				}).error(function (data) {
				$scope.isLoadingPagination = false;
				$scope.errors = data.errors;
			});

		}

        if($location.path() == $scope.path+'/reportDetail') {
            $scope.columns = {
                'food_product_name':{'label':'Denumire', 'filter':1, 'filterType':'input'},
                'food_product_code':{'label':'Code', 'filter':1, 'filterType':'input'},
                'food_category_name':{'label':'Categorie', 'filter':1, 'filterType':'input'},
                //'status':{'label':'Status', 'filter':1, 'filterType':'select'},
				'total_quantity':{'label':'Total cantitate (buc)', 'filter':1, 'filterType':'input'},
				/*'total_price':{'label':'Total pret ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
				'total_packaging':{'label':'Total ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay},
                'total':{'label':'Total ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay}*/
            };

           /* $scope.columns.status.options = [
                {'id':'', 'value' : ''},
                {'id':1, 'value' : 'true'},
                {'id':0, 'value' : 'false'}
            ];*/
            $scope.search['reportType'] = 'reportDetail';
            $scope.additionals['reportType'] = 'reportDetail';
            $scope.title = 'Vanzari produse / Raport detaliat';
            $scope.classAction = 'td-small';
        }

        if($location.path() == $scope.path+'/reportDaily') {
            $scope.controlGetOrder = false;
            $scope.columns = {
                'date':{'label':'Data', 'filter':1, 'filterType':'input'},
                'food_product_name':{'label':'Denumire', 'filter':1, 'filterType':'input'},
                'food_product_code':{'label':'Code', 'filter':1, 'filterType':'input'},
                'total_quantity':{'label':'Total cantitate (buc)', 'filter':1, 'filterType':'input'},
				/*'total_price':{'label':'Total pret ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
				'total_packaging':{'label':'Total ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay},
                'total':{'label':'Total ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay}*/
            };

            $scope.search['reportType'] = 'reportDaily';
            $scope.additionals['reportType'] = 'reportDaily';
            $scope.title = 'Vanzari produse / Raport zilnic';
            $scope.classAction = 'td-small';
            $scope.search.order = 'desc';
        }

        $scope.changeColumns = function (reportTypeGeneral) {
            $scope.classAction = 'td-small';
            if(reportTypeGeneral == 'food_product_name') {
                $scope.columns = {
                    'food_product_name':{'label':'Denumire', 'filter':1, 'filterType':'input'},
					'total_quantity':{'label':'Total cantitate (buc)', 'filter':1, 'filterType':'input'},
					'total_price':{'label':'Total pret ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
					'total_packaging':{'label':'Total ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay},
					'total_product_discount':{'label':'Discount produse ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    'total':{'label':'Total ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
                };
            }
            if(reportTypeGeneral == 'day') {
                $scope.columns = {
                    'date':{'label':'Data', 'filter':1, 'filterType':'input'},
					'total_quantity':{'label':'Total cantitate (buc)', 'filter':1, 'filterType':'input'},
					'total_price':{'label':'Total pret ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
					'total_packaging':{'label':'Total ambalaj ('+$rootScope.currency+')', 'filter':1, 'filterType':'input', 'nonDisplay':$scope.nonDisplay},
					'total_product_discount':{'label':'Discount produse ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'},
                    'total':{'label':'Total ('+$rootScope.currency+')', 'filter':1, 'filterType':'input'}
                };
            }

        }
        if($location.path() == $scope.path+'/reportGeneral') {
            $scope.search.reportTypeGeneral = 'food_product_name';
            if (angular.isUndefined($scope.search.reportTypeGeneral)) { $scope.search.reportTypeGeneral = 'food_product_name';}
            $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            $scope.searchModel = function (ev, path) {
                $scope.searchControl = true;
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
                $scope.changeColumns($scope.search.reportTypeGeneral);
                $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
            }
            $scope.controlGetOrder = false;
            $scope.search['reportType'] = 'reportGeneral';
            $scope.additionals['reportType'] = 'reportGeneral';
            $scope.title = 'Vanzari produse / Raport general';
            $scope.classAction = 'td-small';
            $scope.search.order = 'desc';
        }

        /* show model report general */
        $scope.additionals['getCount'] = function(i, arr) {
            var iCount = iCount || 0;
            for (var j = 0; j < arr.length; j++) {
                if (arr[j] == i) {
                    iCount++;
                }
            }
            return iCount;
        }
        $scope.showModelReportGeneral = function (ev, path, model) {
            if($scope.mode_action == 'page') {
                $scope.controlSH = true;
                $scope.action = 'show';
                angular.element(document.querySelector('.fill-height')).animate({ scrollTop: 250 }, "slow");
                $scope.modelData = {};
                $scope.modelData = model;

                if(typeof model.food_product_names === 'string') {
                    $scope.modelData.food_product_names = model.food_product_names.split(', ');
                }
                if(typeof model.food_product_ids === 'string') {
                    $scope.modelData.food_product_ids = model.food_product_ids.split(', ');
                }
                $scope.cancel = function () {
                    $scope.modelData = {};
                    $scope.errors = {};
                    $scope.controlSH = false;
                };
            }
            if($scope.mode_action == 'dialog') {
                var typeRequest = 'form-urlencoded';
                model['route'] = 'showReportGeneral';
                $mdDialog.show({
                    controller: DialogController,
                    templateUrl: 'showDialog.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        path: $scope.path,
                        pathTemplate: $scope.pathTemplate,
                        model: model,
                        search: $scope.search,
                        formatText: $scope.formatText,
                        formatDate: $scope.formatDate,
                        columns: $scope.columns,
                        additionals: $scope.additionals
                    },
                });
                DialogController.$inject = ['$scope', '$mdDialog', 'path', 'pathTemplate', 'model', 'search', 'formatText', 'formatDate', 'columns', 'additionals'];
                function DialogController($scope, $mdDialog, path, pathTemplate, model, search, formatText, formatDate, columns, additionals) {
                    $scope.pathTemplate = pathTemplate;
                    $scope.path = path;
                    $scope.modelData = model;
                    if(typeof model.food_product_names === 'string') {
                        $scope.modelData.food_product_names = model.food_product_names.split(', ');
                    }
                    if(typeof model.food_product_ids === 'string') {
                        $scope.modelData.food_product_ids = model.food_product_ids.split(', ');
                    }
                    $scope.additionals = additionals;
                    $scope.formatText = formatText;
                    $scope.formatDate = formatDate;
                    $scope.columns = columns;
                    $scope.search = search;

                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                }
            }
        };

        $scope.cancelSearchReport = function (ev, path, reportType) {
            $scope.search = {};

            if($scope.searchControl == true) {
                if(!angular.isUndefined(reportType)) {
                    $scope.search['reportType'] = reportType;
                    $scope.additionals['reportType'] = reportType;
                    if(reportType == 'reportGeneral') {
                        $scope.search.reportTypeGeneral = 'food_product_name';
                        $scope.changeColumns($scope.search.reportTypeGeneral);
                        $scope.additionals.reportTypeGeneral = $scope.search.reportTypeGeneral;
                    }
                }
                $scope.getPaginateModel(path, 1, $scope.defaultItem);
            }
            angular.element(document.querySelector('.expand-collapse-content')).slideToggle('200',function() {
                angular.element(document.querySelector('#collapse i')).toggleClass('fa-minus fa-plus');
            });
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            angular.element(document.querySelector('mdp-date-picker .md-input-has-value')).removeClass('md-input-has-value');
            angular.element(document.querySelector('mdp-date-picker .md-input-invalid')).removeClass('md-input-invalid');
            var form = document.getElementById('search-form');
            form.reset();

            $timeout($scope.removeDate, 500);
        }

        /* detail model */
        $rootScope.detailProduct = function (ev) {
            $scope.mode_action = 'dialog';

            Crud.show($routeParams.id, $scope.path)
                .success(function (data) {
                    $scope.modelData = data;
                    $scope.additionals['getFoodCategories']();
                });

            $scope.additionals['getIngredients']();
            $scope.$watch('selectedIndex', function(current, old) {
                if(current == 1) {
                    function dataURLtoBlob(dataurl) {
                        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                        while(n--) {
                            u8arr[n] = bstr.charCodeAt(n);
                        }
                        return new Blob([u8arr], {type:mime});
                    }
                    $scope.addMedia = function (typeRequest) {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.isLoading = true;

                        if(typeRequest == 'form-urlencoded') {
                            $scope.post = $scope.modelData;
                        }

                        if(typeRequest == 'undefined') {
                            $scope.post = new FormData();

                            if (!angular.isUndefined($scope.modelData.images)) {
                                angular.forEach($scope.modelData.images, function (item, key) {
                                    if(key != 0) {
                                        var blob = dataURLtoBlob(item);
                                        $scope.post.append('images[]', blob, 'generic-' + key + '.jpg');
                                    }
                                });
                            }

                            $scope.post.append('route', 'media');
                            $scope.post.append('id', $scope.modelData[$rootScope.typeId]);
                        }
                        if(typeRequest == 'json') {
                            $scope.post = $scope.modelData;
                        }
                        Crud.post(typeRequest, $scope.post, $scope.path + '/media')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, data.currentModel);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = data.currentModel;
                                        }
                                    } else {
                                        if (!angular.isUndefined($scope.models) && !angular.isUndefined($scope.models)) {
                                            $scope.getElement($scope.models, currentModel);
                                        }
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = currentModel;
                                        }
                                    }
                                }
                                $scope.errors = {};
                                $scope.isLoading = false;
                                $scope.additionals['buttonDisabled'] = false;

                            }).error(function (data) {
                            $scope.errors = data.errors;
                            $scope.isLoading = false;
                            $scope.additionals['buttonDisabled'] = false;
                        });
                    };
                }

                if(current == 2) {
                    $scope.addSupplement = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        $scope.modelData['route'] = 'supplement';
                        Crud.post($scope.additionals['content_type'], $scope.modelData, $scope.path+'/supplement')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = data.currentModel;
                                        }
                                    }
                                }
                                $scope.errors = {};
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                    };
                }

                if(current == 3) {

                    var currentModel = {};
                    angular.forEach($scope.modelData, function (item, key) {
                        switch (key) {
                            case 'ingredients':
                                currentModel['ingredients'] = [];
                                angular.forEach(item, function (itemIngredients, keyIngredients) {
                                    $scope.additionals['selectedItemIngredient'][keyIngredients] = '';

                                    currentModel['ingredients'][keyIngredients] = {};
                                    angular.forEach(itemIngredients, function (itemIngredientsDetail, keyIngredientsDetail) {
                                        currentModel['ingredients'][keyIngredients][keyIngredientsDetail] = itemIngredientsDetail;
                                    });
                                });
                                break;
                            default:
                                currentModel[key] = item;
                                break;
                        }
                    });
                    $scope.modelData = currentModel;
                    if(angular.isUndefined(currentModel.ingredients) || currentModel.ingredients.length == 0) {
                        currentModel.ingredients = [{}];
                    }
                    $scope.additionals['ingredients'] = currentModel.ingredients;

                    $scope.addIngredient = function () {
                        $scope.additionals['buttonDisabled'] = true;
                        angular.forEach($scope.modelData.ingredients, function (item, indexIngredients) {
                            if (item['ingredient_name'] != '' && $scope.additionals['ingredientsResults']) {
                                var checkIngredientId = $scope.additionals['checkField']($scope.additionals['ingredientsResults'], 'id', 'ingredient_name', item['ingredient_name']);
                                if (checkIngredientId) {
                                    item.ingredient_id = checkIngredientId;
                                } else {
                                    item.ingredient_id = 0;
                                }
                                var checkIngredientName = $scope.additionals['checkField']($scope.additionals['ingredientsResults'], 'ingredient_name', 'ingredient_name', item['ingredient_name']);
                                if (checkIngredientName) {
                                    item.ingredient_name = checkIngredientName;
                                }
                            }
                        });

                        var post = {};
                        post['route'] = 'ingredient';
                        post['ingredients'] = $scope.modelData['ingredients'];
                        post['id'] = $scope.modelData['id'];
                        Crud.post($scope.additionals['content_type'], post, $scope.path+'/ingredient')
                            .success(function (data) {
                                if (!angular.isUndefined(data.invalid)) {
                                    $scope.additionals['invalid'] = data.invalid;
                                } else {
                                    if (!angular.isUndefined(data.currentModel)) {
                                        if (!angular.isUndefined($scope.modelData)) {
                                            $scope.modelData = data.currentModel;
                                        }
                                    }
                                }
                                $scope.errors = {};
                                $scope.additionals['buttonDisabled'] = false;
                            })
                            .error(function (data) {
                                $scope.isLoading = false;
                                $scope.errors = data.errors;
                                $scope.additionals['buttonDisabled'] = false;
                            });
                    };
                }

            });

        }

    }]
)
.filter('unique', function() {

    return function (arr) {
        if (!angular.isUndefined(arr)) {
            var o = {}, i, l = arr.length, r = [];
            for (i = 0; i < l; i += 1) {
                o[arr[i]] = arr[i];
            }
            for (i in o) {
                r.push(o[i]);
            }
            return r;
        }
    };
})
